import { Box, Grid, styled, TableCell, TableRow } from "@mui/material";
import {
  BLUEBACKGROUND,
  GRAYPALEBACKGROUND1,
  GRAYPALECONTENTS,
  GRAYPALETITLE,
} from "../../../styles/color";

export const MeetingRoomNoticeBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: "1px solid #DCDFE3",
  borderRadius: "4px",

  padding: "0px 8px",
}));

export const MeetingRoomRightBoxTitle = styled(Box)(() => ({
  color: GRAYPALETITLE,
  fontWeight: 500,
  marginRight: "12px",
}));

export const MeetingRoomRightBoxSideColor = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  color: GRAYPALECONTENTS,
  cursor: "pointer",
  textAlign: "right",
}));

export const MeetingRoomNoticeIcon = styled("img")(() => ({
  width: "20px",
  marginTop: "-3px",
  marginRight: "4px",
}));

export const MeetingRoomMainStyledTableRow = styled(TableRow)({
  cursor: "pointer",
  backgroundColor: GRAYPALEBACKGROUND1,
  "&:hover": { backgroundColor: BLUEBACKGROUND },
});

export const MeetingRoomStyledTableRow = styled(TableRow)({
  cursor: "pointer",
  "&:hover": { backgroundColor: BLUEBACKGROUND },
});

export const MeetingRoomStyledHead1 = styled(TableCell)({
  fontFamily: "Noto sans CJK KR",
  backgroundColor: "#F0F2F5",
  borderTop: "1px solid #DCDFE3",
  borderBottom: "1px solid #DCDFE3",
  width: "150px",
  padding: "0.6rem",
  whiteSpace: "nowrap" as const,
  fontSize: "1rem",
  color: GRAYPALETITLE,
  fontWeight: "bold",
  height: "2rem",
});

export const MeetingRoomStyledHead2 = styled(TableCell)({
  fontFamily: "Noto sans CJK KR",
  backgroundColor: "#F0F2F5",
  borderTop: "1px solid #DCDFE3",
  borderBottom: "1px solid #DCDFE3",
  width: "50px",
  padding: "0.6rem",
  whiteSpace: "nowrap" as const,
  fontSize: "1rem",
  color: GRAYPALETITLE,
  fontWeight: "bold",
  height: "2rem",
});

export const MeetingRoomStyledHead3 = styled(TableCell)({
  fontFamily: "Noto sans CJK KR",
  backgroundColor: "#F0F2F5",
  borderTop: "1px solid #DCDFE3",
  borderBottom: "1px solid #DCDFE3",
  width: "550px",
  padding: "0.6rem",
  whiteSpace: "nowrap" as const,
  fontSize: "1rem",
  color: GRAYPALETITLE,
  fontWeight: "bold",
  height: "2rem",
});

export const MeetingRoomStyledBody = styled(TableCell)({
  fontFamily: "Noto sans CJK KR",
  borderTop: "1px solid #DCDFE3",
  borderBottom: "1px solid #DCDFE3",
  padding: "0.7rem",
  fontSize: "1rem",
  height: "2rem",
});

export const NoticeTitleWrapper = styled(Box)({
  display: "flex",
  flex: 10,
  height: "40px",
  alignItems: "center",
});

export const NoticeTitleBox = styled(Box)(() => ({
  position: "relative",

  cursor: "pointer",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "flex",
  alignItems: "center",
}));

export const NoticeTitleSpanBox = styled(Grid)(() => ({
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "100%",
}));
